import MeterQuiz from "@/components/MeterQuiz";
import { FUR_METER } from "@/lib/meterQuizzes";

export default function FurMeter() {
  return <MeterQuiz config={FUR_METER} />;
}
